import * as homeActions from "../../services/home/actions";
import { connect } from "react-redux";

function mapStateToProps(state) {
  return {
    home: state.home,
    deposit: state.orders.deposit.data,
    withdraw: state.orders.withdraw.data,
    orders: state.orders,
    borrowerOrders: state.borrowerOrders,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchOrdersData: () => {
      dispatch(homeActions.fetch_orders_data());
    },
    fetchBorrowerOrdersData: () => {
      dispatch(homeActions.fetch_borrower_orders_data());
    },
  };
}

export const menuOrdersConnector = connect(mapStateToProps, mapDispatchToProps);
